import React, { useEffect, useRef } from "react";
import "../../App.css";

export default function BubbleCanvas() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    const resizeCanvas = () => {
      canvas.width = canvas.parentElement.clientWidth;
      canvas.height = canvas.parentElement.clientHeight;
    };

    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    class Bubble {
      constructor() {
        this.reset();
      }
      reset() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.radius = 50 + Math.random() * 150;
        this.speedX = (Math.random() - 0.5) * 5.5;
        this.speedY = (Math.random() - 0.5) * 5.5;
        this.opacity = 0.3 + Math.random() * 0.4;
        this.currentOpacity = 0;
        this.fadeSpeed = this.opacity / 20;
        this.color = `${Math.random() * 100}, ${Math.random() * 250}`;
      }
      move() {
        this.x += this.speedX;
        this.y += this.speedY;
        if (
          this.x < -this.radius ||
          this.x > canvas.width + this.radius ||
          this.y < -this.radius ||
          this.y > canvas.height + this.radius
        ) {
          this.reset();
        }
      }
      draw() {
        if (this.currentOpacity < this.opacity) {
          this.currentOpacity += this.fadeSpeed;
          if (this.currentOpacity > this.opacity) {
            this.currentOpacity = this.opacity;
          }
        }

        ctx.beginPath();
        ctx.arc(this.x, this.y, this.radius, 0, Math.PI * 2);
        const gradient = ctx.createRadialGradient(
          this.x,
          this.y,
          this.radius * 0.6,
          this.x,
          this.y,
          this.radius
        );
        gradient.addColorStop(0, `rgba(180,${this.color}, ${this.currentOpacity})`);
        gradient.addColorStop(1, `rgba(90,${this.color}, 0.5)`);
        ctx.fillStyle = gradient;
        ctx.fill();
      }
    }

    const bubbles = Array.from({ length: 7 }, () => new Bubble());

    let lastTime = 0;
    const fps = 20;
    const frameDuration = 1000 / fps;

    const animate = (time) => {
      if (time - lastTime < frameDuration) {
        requestAnimationFrame(animate);
        return;
      }
      lastTime = time;

      ctx.clearRect(0, 0, canvas.width, canvas.height);
      bubbles.forEach((b) => {
        b.move();
        b.draw();
      });
      requestAnimationFrame(animate);
    };
    animate();

    return () => {
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <canvas
      id="bubbleCanvas"
      ref={canvasRef}
    ></canvas>
  );
}
